import React from "react";
import {
    Button, Flex, Icon, Modal, ModalBody, ModalCloseButton, ModalContent,
    ModalFooter, ModalHeader, ModalOverlay, Spinner, Text,
} from "@chakra-ui/react";
import { MdBuild } from "react-icons/md";
import MigrationResultsContent from "./MigrationResultsContent";

/**
 * Renders the migration dialog content: spinner, results, or nothing.
 * @param {Object} props
 * @param {boolean} props.loading - Whether migration is running
 * @param {Object|null} props.result - Migration result data
 * @returns {React.ReactElement|null}
 */
function MigrationDialogBody({ loading, result }) {
    if (loading) {
        return <Flex justify="center" align="center" minH="200px"><Spinner color="brand.500" /></Flex>;
    }
    if (result) return <MigrationResultsContent data={result.contact_cards_migration} />;
    return null;
}

/**
 * Dialog that shows the progress and results of the
 * DECLINED -> EXPIRED contact cards migration.
 * @param {object} props
 * @param {boolean} props.open - Whether the dialog is visible
 * @param {boolean} props.loading - Whether the migration is in progress
 * @param {object|null} props.result - Migration API response data
 * @param {Function} props.onClose - Callback to close the dialog
 * @returns {React.ReactElement}
 */
function MigrationDialog({ open, loading, result, onClose }) {
    return (
        <Modal isOpen={open} onClose={onClose} size="3xl" scrollBehavior="inside" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Flex align="center" gap="8px">
                        <Icon as={MdBuild} w="20px" h="20px" />
                        <Text>Contact cards migration</Text>
                    </Flex>
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <MigrationDialogBody loading={loading} result={result} />
                </ModalBody>
                <ModalFooter>
                    <Button variant="outline" onClick={onClose}>Close</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default MigrationDialog;
